var exports = {
  "M": "withImage__jJXxA-",
};

module.exports = exports;
